import { render, staticRenderFns } from "./header.vue?vue&type=template&id=0958dff8&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0958dff8')) {
      api.createRecord('0958dff8', component.options)
    } else {
      api.reload('0958dff8', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=0958dff8&", function () {
      api.rerender('0958dff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/job/module/header.vue"
export default component.exports